<div class="w-full flex items-center justify-between py-2">
    <!-- Left: Back button (conditional) or Logo -->
    <div class="flex items-center gap-3">
        <!-- Back button: only shown when showBack=true -->
        <button *ngIf="showBack" type="button" (click)="goBack()"
            class="flex items-center justify-center w-8 h-8 rounded-xl bg-surface/60 hover:bg-primary/10 text-text-muted hover:text-primary border border-foreground/5 transition-all duration-200 group">
            <iconify-icon icon="mdi:arrow-left" width="16" height="16"
                class="transition-transform group-hover:-translate-x-0.5"></iconify-icon>
        </button>

        <!-- Logo -->
        <div class="flex items-center gap-2 group cursor-default">
            <div class="w-1.5 h-6 bg-primary rounded-full transform transition-all group-hover:h-8"></div>
            <span class="text-xl font-black tracking-tighter text-foreground">DENTIUM SYS</span>
            <span class=" bg-primary/10 h-8  rounded-md">
                <img src="assets/images/logos/logo_icon.png" alt="Dentium Logo" class="w-full h-full p-2 object-contain">
            </span>
        </div>
    </div>

    <!-- Right: Theme toggle -->
    <div class="flex items-center gap-2">
        <app-theme-toggle></app-theme-toggle>
    </div>
</div>